import React from 'react';
import './PolicyIsolationismDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  POLICY_ISOLATIONISM_MELEE_BONUS,
  POLICY_ISOLATIONISM_SPECIAL_BUILDING_DISCOUNT
} from "../../../../configs/policy/isolationism";

const PolicyIsolationismDescription = () => {
  const specialBuilding = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right'}
    src={'/img/hexes/special buildings/special building.c496c562.png'}
    alt={'Специальное строение'}
    title={'Специальное строение'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const buildingDiscount =
    <CoinsStat
      text={POLICY_ISOLATIONISM_SPECIAL_BUILDING_DISCOUNT}
      noShrinkOnMobile={true}
      isDarkColor={true}
      className={'policy-description-icon-margin-right-left'}
    />;

  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;

  const freeAction = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/free action.png'}
    alt={'Свободное действие'}
    title={'Свободное действие (не учитывается лимитом действий в Фазе Строительства)'}
  />;

  const initiative = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/initiative.png'}
    alt={'Инициатива'}
    title={'Инициатива (право первого хода в фазе)'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />


  const damageBonus = <span className={'text-war'}>
    {`+${POLICY_ISOLATIONISM_MELEE_BONUS}`}
  </span>;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  return (
    <>
      <div className={'policy-description_line'}>
        {specialBuilding} дешевле {discountElement} на {buildingDiscount}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Все {unit} имеют {damageBonusValueAndIcon} в своих {city}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph-large'}>
        Сразу после покупки Изоляционизма:
      </div>
      <div className={'policy-description_line'}>
        • {freeAction} можно перехватить {initiative},
      </div>
      <div className={'policy-description_line'}>
        • у игрока нельзя перехватить {initiative}.
      </div>
    </>
  );
};

export default PolicyIsolationismDescription;
